module.exports = __webpack_public_path__ + "static/top-city-be82bf98b4ecf9ce2a2367f94ed2ecc6.svg";